export default __webpack_public_path__ + "static/media/about-us-image.6d2ac862.jpg";